import React, {useEffect, useState} from 'react';
import {useLocation, useParams} from "react-router-dom";
import {Box, Button,} from "@mui/material";
import JobMetricOrderOrganizationTable
    from "../../../components/UI/table/orders/organization/estimate/JobMetricOrderOrganizationTable";
import CustomerEstimateOrganizationCostMaterialTable
    from "../../../components/UI/table/orders/customer/order/CustomerEstimateOrganizationCostMaterialTable";
import CustomerMaterialEstimateUnitService
    from "../../../API/orders/estimate/customer/CustomerMaterialEstimateUnitService";
import CustomerEstimateOrganizationTotalMaterialTable
    from "../../../components/UI/table/orders/customer/order/CustomerEstimateOrganizationTotalMaterialTable";
import {constantsErrorMessages} from "../../../Constants";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {
    buildMyOrdersSectionPath,
    CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
} from "../../../utils/customerBreadcrumbLabels";
import Typography from "@mui/material/Typography";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {ButtonGroupTabBar} from "../../../components/UI/button/ButtonGroupTabBar";
import CheckIcon from "@mui/icons-material/Check";
import InformationAboutPerformer from "./InformationAboutPerformer";

const CustomerOrganizationEstimateItem = ({}) => {
    const pathname = useLocation().pathname
    const [alertData, setAlertData] = useState({});
    const params = useParams();
    const {orderId, customerOrderNumber, estimateId, base, alternative, organizationName, estimateState} = params;
    const [tab, setTab] = useState(1);
    const [JobMetricOrderOrganization, setJobMetricOrderOrganization] = useState([]);
    const [materialEstimateUnit, setMaterialEstimateUnit] = useState([]);
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData(pathname, "pageSize", nextState.pageSize)
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const pageSize = pagesData[pathname]?.pageSize
        pageSize && setTableOptions((prev) => ({...prev, pageSize: pageSize}))
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleChangeTab = (tab) => {
        setTab(tab)
        EditLocalStoragePagesData(pathname, "tab", tab)
    }

    useEffect(() => {
        getStartPageSize()
        CustomerMaterialEstimateUnitService.getAllByEstimateOrganization(estimateId)
            .then(function (response) {
                const fetchedData = response.data;
                setTableOptions((prev) => ({...prev, totalElements: fetchedData.length}))
                setMaterialEstimateUnit(fetchedData);
                const calculationWithJobMetric = [];
                fetchedData.forEach(item => {
                    let jobMetricOrderOrganizations = item.jobMetricOrderOrganizations;
                    if (jobMetricOrderOrganizations) {
                        calculationWithJobMetric.push(...item.jobMetricOrderOrganizations);
                    }
                });
                setJobMetricOrderOrganization(calculationWithJobMetric);
            })
            .catch(function (error) {
                handleModalAlert(error);
            });
    }, [estimateId]);


    const generalTabComponents = [
        {
            tabIndex: 1, label: "Итоги",
            component: <CustomerEstimateOrganizationTotalMaterialTable
                data={materialEstimateUnit}
                setData={setMaterialEstimateUnit}
                orderId={orderId}
                estimateId={estimateId}
                baseCurrency={base}
                alternativeCurrency={alternative}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
                estimateState={estimateState}
            />
        }, {
            tabIndex: 2, label: "Стоимость материалов",
            component: <CustomerEstimateOrganizationCostMaterialTable
                data={materialEstimateUnit}
                setData={setMaterialEstimateUnit}
                estimateId={estimateId}
                baseCurrency={base}
                alternativeCurrency={alternative}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
            />
        }, {
            tabIndex: 3, label: "Стоимость работ",
            component: <JobMetricOrderOrganizationTable
                customer={true}
                data={JobMetricOrderOrganization}
                setData={setJobMetricOrderOrganization}
                currency={[{id: 1, value: base}, {id: 2, value: alternative}]}
                tableOptions={tableOptions}
                tableOptionsHandle={tableOptionsHandle}
                handleModalAlert={handleModalAlert}
            />
        }, {
            tabIndex: 4, label: "Информация об исполнителе",
            component:
                <InformationAboutPerformer
                    name={organizationName}
                    handleModalAlert={handleModalAlert}
                />
        },]


    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Подробная смета`}
                path={buildMyOrdersSectionPath(
                    CUSTOMER_ORDERS_SUBMENU_BREADCRUMB,
                    {
                        name: `Заказ ${customerOrderNumber}`,
                        href: `/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}`,
                    },
                    {
                        name: `Предложение заказа ${customerOrderNumber}`,
                        href: `/customer/orders/${orderId}/${encodeURIComponent(customerOrderNumber)}/estimates`,
                    },
                )}
            />
            <Box sx={{display: "flex", flexDirection: "column", gap: "32px"}}>
                <Typography component="p" sx={{fontSize: "24px", fontWeight: 700}}>
                    Подробная смета
                </Typography>
                <ButtonGroupTabBar activeTab={tab}>
                    {generalTabComponents.map(({tabIndex, label}, index) => {
                        return <Button key={tabIndex} tabIndex={tabIndex} onClick={() => handleChangeTab(tabIndex)}>
                            <CheckIcon/>
                            {label}
                        </Button>
                    })}
                </ButtonGroupTabBar>
                {generalTabComponents.find(component => component.tabIndex === tab)?.component}
            </Box>
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default CustomerOrganizationEstimateItem;